//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LandingSectionHeader',
  props: {
    icon: {
      type: Array,
      default: () => [],
    },
    iconClass: {
      type: String,
      default: 'text-muted',
    },
  },
};
